export default __webpack_public_path__ + "static/media/grafico.bc2bdb39.png";